export interface ThemeColorTitleInterface {
    key: string;
    title: string;
}

export const AVAILABLE_COLORS_TITLES: ThemeColorTitleInterface[] = [
    { key: '--rgb-main-background-color', title: 'page.body.customization.themes.color.mainBackgroundColor' },
    { key: '--rgb-body-background-color', title: 'page.body.customization.themes.color.bodyBackgroundColor' },
    { key: '--rgb-header-background-color', title: 'page.body.customization.themes.color.headerBackgroundColor' },
    { key: '--rgb-subheader-background-color', title: 'page.body.customization.themes.color.subheaderBackgroundColor' },
    { key: '--rgb-dropdown-background-color', title: 'page.body.customization.themes.color.dropdownBackgroundColor' },
    { key: '--rgb-icons', title: 'page.body.customization.themes.color.icon' },
    { key: '--rgb-primary-cta-color', title: 'page.body.customization.themes.color.primaryCtaColor' },
    { key: '--rgb-contrast-cta-color', title: 'page.body.customization.themes.color.contrastCtaColor' },
    { key: '--rgb-secondary-contrast-cta-color', title: 'page.body.customization.themes.color.secondaryContrastCtaColor' },
    { key: '--rgb-cta-layer-color', title: 'page.body.customization.themes.color.ctaLayerColor' },
    { key: '--rgb-system-green', title: 'page.body.customization.themes.color.systemGreen' },
    { key: '--rgb-system-red', title: 'page.body.customization.themes.color.systemRed' },
    { key: '--rgb-system-yellow', title: 'page.body.customization.themes.color.systemYellow' },
    { key: '--rgb-asks', title: 'page.body.customization.themes.color.asks' },
    { key: '--rgb-bids', title: 'page.body.customization.themes.color.bids' },
    { key: '--rgb-primary-text-color', title: 'page.body.customization.themes.color.primaryTextColor' },
    { key: '--rgb-text-contrast-color', title: 'page.body.customization.themes.color.textContrastColor' },
    { key: '--rgb-input-background-color', title: 'page.body.customization.themes.color.inputBackgroundColor' },
    { key: '--rgb-divider-color', title: 'page.body.customization.themes.color.dividerColor' },
    { key: '--rgb-shadow-color', title: 'page.body.customization.themes.color.shadowColor' },
    { key: '--rgb-landing-background-color', title: 'page.body.customization.themes.color.landingBackgroundColor' },
    { key: '--rgb-strength-meter-very-strong', title: 'page.body.customization.themes.color.strengthMeterVeryStrong' },
];
